import React from 'react';
import { useShop } from '../context/ShopContext';
import { Star, CheckCircle2 } from 'lucide-react';

export default function Testimonials() {
  const { testimonialsData } = useShop();
  const reviews = Array.isArray(testimonialsData) ? testimonialsData : [];

  return (
    <section style={{ padding: '0 0 36px', backgroundColor: '#f1f3f6' }}>
      <div className="container">
        
        {/* Flipkart White Card Reviews Box */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '2px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
          padding: '24px'
        }}>
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '20px',
            borderBottom: '1px solid #f0f0f0',
            paddingBottom: '14px'
          }}>
            <div>
              <h2 style={{
                fontSize: '1.28rem',
                fontWeight: 700,
                color: '#212121'
              }}>
                Ratings & Customer Reviews
              </h2>
              <span style={{ fontSize: '0.78rem', color: '#878787' }}>
                Real feedback from 100% verified jewelry buyers
              </span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{
                backgroundColor: '#388e3c',
                color: '#ffffff',
                fontSize: '0.85rem',
                fontWeight: 700,
                padding: '3px 8px',
                borderRadius: '3px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '3px'
              }}>
                4.9 <Star size={12} fill="#ffffff" color="#ffffff" />
              </span>
              <span style={{ fontSize: '0.78rem', color: '#878787' }}>Overall Rating</span>
            </div>
          </div>

          {/* Reviews Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '16px'
          }}>
            {reviews.map((rev) => (
              <div
                key={rev.id || rev.name}
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #f0f0f0',
                  borderRadius: '2px',
                  padding: '16px',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* Rating & Verified Tag */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <span style={{
                    backgroundColor: '#388e3c',
                    color: '#ffffff',
                    fontSize: '0.72rem',
                    fontWeight: 700,
                    padding: '2px 6px',
                    borderRadius: '3px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '2px'
                  }}>
                    {rev.rating || 5} <Star size={10} fill="#ffffff" color="#ffffff" />
                  </span>
                  <span style={{ fontSize: '0.82rem', fontWeight: 600, color: '#212121' }}>
                    Excellent Quality
                  </span>
                </div>

                {/* Review Text */}
                <p style={{
                  color: '#424242',
                  fontSize: '0.84rem',
                  lineHeight: 1.5,
                  marginBottom: '12px',
                  flex: 1
                }}>
                  "{rev.quote}"
                </p>

                {/* Reviewer Details */}
                <div style={{
                  borderTop: '1px solid #f0f0f0',
                  paddingTop: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  fontSize: '0.75rem',
                  color: '#878787'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span style={{ fontWeight: 600, color: '#212121' }}>{rev.name}</span>
                    <span style={{ color: '#388e3c', display: 'inline-flex', alignItems: 'center', gap: '2px', fontWeight: 600 }}>
                      <CheckCircle2 size={12} /> Certified Buyer
                    </span>
                  </div>
                  <span>{rev.date || 'Recent'}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
